/**
 * okaidia theme for JavaScript, CSS and HTML
 * Loosely based on Monokai textmate theme by http://www.monokai.nl/
 * @author ocodia
 */

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #f8f8f2;
	--pce-bg: #272822;
	--pce-widget-border: #4f5148;
	--pce-widget-bg: #242622;
	--pce-widget-color: #cfd1c7;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #9ea092;
	--pce-widget-bg-input: #35372f;
	--pce-widget-bg-hover: #5a5d5e4f;
	--pce-widget-bg-active: #99947c66;
	--pce-widget-focus: #99947c;
	--pce-search-match: #ea5c0054;
	--pce-widget-bg-error: #5a1d1d;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #36362b;
	--pce-selection-match: #575b6180;
	--pce-line-number: #90908a;
	--pce-scrollbar: 0, 0%, 45%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #9e9f9640;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #575a5a;
	color-scheme: dark;
}

.pce-match {
	--pce-search-match: #885a3c;
}

.active-line {
	--pce-line-number: #c2c2bf;
}

.active-indent {
	--pce-guide-indent: #dbdbd973;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: #8292a2;
}

[class*="language-"],
.token.punctuation,
.token.attr-equals {
	color: #f8f8f2;
}

.token.namespace {
	opacity: 0.7;
}

.token.property,
.token.tag,
.token.constant,
.token.symbol,
.token.deleted,
.token.block > .keyword,
.token.keyword.control-flow,
.token.keyword.module {
	color: #f92672;
}

.token.boolean,
.token.number {
	color: #ae81ff;
}

.token.selector,
.token.attr-name,
.token.string,
.token.string-property,
.token.char,
.token.builtin,
.token.inserted {
	color: #a6e22e;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string,
.token.variable {
	color: #f8f8f2;
}

.token.atrule,
.token.attr-value,
.token.function,
.token.class-name {
	color: #e6db74;
}

.token.keyword {
	color: #66d9ef;
}

.token.regex,
.language-regex,
.token.important {
	color: #fd971f;
}

.token.important,
.token.bold {
	font-weight: bold;
}
.token.italic {
	font-style: italic;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #ffd700;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #da70d6;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #179fff;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #888, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #4a4a7680;
}
